if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.isVariantQuantityEnabled = this.dataset.variantQuantity;
        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer') ||
          document.querySelector('ajax-cart');
        this.submitButton = [
          this.querySelector('[type="submit"]'),
          document.querySelector('[data-product-form-submit]')
        ].filter((item) => item !== null && item !== undefined);
        if (document.querySelector('cart-drawer')) {
          this.submitButton.forEach((element) => {
            element.setAttribute('aria-haspopup', 'dialog');
          });
        }
        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        this.submitButton.forEach((element) => {
          if (element.getAttribute('aria-disabled') === 'true') return;
        });

        this.handleErrorMessage();

        this.submitButton.forEach((element) => {
          element.setAttribute('aria-disabled', true);
          element.classList.add('loading');
          element.querySelector('.loading-overlay__spinner').classList.remove('hidden');
        });

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        let formData;
        if (this.isVariantQuantityEnabled == 'true') {
          const allVariantQuantity = document.querySelectorAll('variant-quantity');
          formData = {};
          formData['items'] = [];
          allVariantQuantity.forEach((element) => {
            const inputElement = element.querySelector('input');
            const inputElementQuantity = +inputElement.value;
            if (inputElementQuantity > 0) {
              formData['items'].push({id: inputElement.dataset.id, quantity: inputElementQuantity});
            }
          });
          const uniqueObjects = {};
          const resultArray = [];
          for (const obj of formData['items']) {
            const key = JSON.stringify(obj);
            if (!uniqueObjects[key]) {
              uniqueObjects[key] = true;
              resultArray.push(obj);
            }
          }
          formData['items'] = resultArray;
          const customFormData = new FormData();
          for (const key in formData) {
            if (Array.isArray(formData[key])) {
              for (let i = 0; i < formData[key].length; i++) {
                for (const innerKey in formData[key][i]) {
                  customFormData.append(`items[${i}][${innerKey}]`, formData[key][i][innerKey]);
                }
              }
            } else {
              customFormData.append(key, formData[key]);
            }
          }
          if (this.cart && this.cart.getSectionsToRender) {
            formData['sections'] = this.cart.getSectionsToRender().map((section) => section.id);
            formData['sections_url'] = window.location.pathname;
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = customFormData;
        } else {
          formData = new FormData(this.form);
          if (this.cart && this.cart.getSectionsToRender) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: config.body.get('id'),
                errors: response.description,
                message: response.message
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton[0].querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.forEach((element) => {
                element.setAttribute('aria-disabled', true);
                element.querySelector('span').classList.add('hidden');
              });
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;
            if (!this.error && this.isVariantQuantityEnabled == 'false') {
              publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: config.body.get('id')});
            }

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    if (window.cartType === 'p80') {
                      this.cart.toggleCart();
                    } else {
                      this.cart.renderContents(response);
                    }
                  });
                },
                {once: true}
              );
              quickAddModal.hide(true);
            } else {
              if (window.cartType === 'p80') {
                this.cart.toggleCart();
              } else {
                this.cart.renderContents(response);
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.forEach((element) => {
              element.classList.remove('loading');
            });
            if (this.cart && this.cart.classList.contains('is-empty') && window.cartType !== 'p80')
              this.cart.classList.remove('is-empty');
            if (!this.error) {
              this.submitButton.forEach((element) => {
                element.removeAttribute('aria-disabled');
              });
            }
            this.submitButton.forEach((element) => {
              element.querySelector('.loading-overlay__spinner').classList.add('hidden');
            });
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

class VariantQuantity extends HTMLElement {
  constructor() {
    super();
    this.decreaseQuantity = this.querySelector('button[name="minus"]');
    this.increaseQuantity = this.querySelector('button[name="plus"]');
    this.variantInput = this.querySelector('input[type="number"]');
    this.variantPrice = this.dataset.variantPrice;

    this.variantQuantityTotal = this.dataset.quantityTotal;

    this.variantTotalPrice = this.closest('tr').querySelectorAll('[data-variant-totals]');
    this.totalPrice;
    this.allVariantsTotalPrice = document.querySelectorAll('[data-variants-total-price]');
    this.allAddToCartButton = document.querySelectorAll('[data-variant-add-to-cart]');
    this.enableCurrencyCode = this.dataset.currencyCode;
    this.currency = Shopify && Shopify.currency ? Shopify.currency.active : null;
    this.getLang = () => {
      if (navigator.languages != undefined) return navigator.languages[0];
      return navigator.language;
    };

    this.debouncedOnChange = debounce((event) => {
      this.handleUpdateTotals();
    }, 300);

    this.decreaseQuantity.addEventListener('click', this.handleDecreaseQuantity);
    this.increaseQuantity.addEventListener('click', this.handleIncreaseQuantity);
    this.variantInput.addEventListener('change', this.debouncedOnChange);
  }

  handleIncreaseQuantity = () => {
    const getInputValue = +this.variantInput.value;
    +this.variantQuantityTotal > getInputValue ? (this.variantInput.value = getInputValue + 1) : '';

    this.variantInput.dispatchEvent(this.customEventCall('change'));
  };

  handleDecreaseQuantity = () => {
    const getInputValue = +this.variantInput.value;
    0 < getInputValue ? (this.variantInput.value = getInputValue - 1) : '';

    this.variantInput.dispatchEvent(this.customEventCall('change'));
  };

  handleUpdateTotals = () => {
    +this.variantInput.value > +this.variantQuantityTotal ? (this.variantInput.value = +this.variantQuantityTotal) : '';
    // SET ALL VARIANT QUANTITY INPUT INSIDE THIS TD ELEMENT TO BE THE SAME INPUT VALUE AS THE OTHERS
    const closestTrElement = this.closest('tr');
    closestTrElement.querySelectorAll('.quantity__input').forEach((element) => {
      element.value = +this.variantInput.value;
    });
    // END
    closestTrElement.querySelectorAll('variant-quantity').forEach((element) => {
      +element.variantInput.value > 0
        ? element.classList.add('product__variant-quantity--active')
        : element.classList.remove('product__variant-quantity--active');
    });
    const computePrice = +this.variantPrice * +this.variantInput.value;
    const totalPrice = this.computePrice(computePrice);

    this.variantTotalPrice.forEach((element) => {
      element.dataset.variantMainTotal ? (element.dataset.variantMainTotal = computePrice) : '';
      element.textContent = totalPrice;
    });

    this.handleAllVariantsTotalPrice();
  };

  handleAllVariantsTotalPrice = () => {
    this.onPriceChangeLoading(true);
    const reflectTotalQuantity = document.querySelectorAll('[data-variant-total-quantity]');
    const variantQuantityInput = [...document.querySelectorAll('tbody tr')].map((tr) => {
      const quantityInput = tr.querySelector('.quantity__input');
      if (!quantityInput) return 0;
      return parseInt(tr.querySelector('.quantity__input').value) || 0;
    });
    const totalQuantity = variantQuantityInput.reduce((total, currentValue) => total + currentValue, 0);
    reflectTotalQuantity.forEach((element) => {
      element.textContent = totalQuantity;
    });
    const allVariantsTotalPrice = document.querySelectorAll('[data-variant-main-total]');
    let totalPrice = 0;
    allVariantsTotalPrice.forEach((element) => {
      totalPrice += +element.dataset.variantMainTotal;
    });

    if (this.allVariantsTotalPrice) {
      this.allVariantsTotalPrice.forEach((element) => {
        element.textContent = this.computePrice(totalPrice);
      });
    }
    this.totalPrice = totalPrice;

    if (this.totalPrice > 0) {
      this.allAddToCartButton.forEach((element) => {
        element.classList.add('product-form__submit--has-variant');
        element.classList.remove('product-form__submit--no-variant');
        element.removeAttribute('disabled');
      });
    } else {
      this.allAddToCartButton.forEach((element) => {
        element.classList.remove('product-form__submit--has-variant');
        element.classList.add('product-form__submit--no-variant');
        element.setAttribute('disabled', true);
      });
    }
    this.onPriceChangeLoading(false);
  };

  computePrice = (price) => {
    if (this.enableCurrencyCode == 'true') {
      return (
        (price / 100).toLocaleString(this.getLang(), {
          style: 'currency',
          currency: this.currency
        }) +
        ' ' +
        this.currency
      );
    } else {
      return (price / 100).toLocaleString(this.getLang(), {
        style: 'currency',
        currency: this.currency
      });
    }
  };

  customEventCall = (event) => {
    return new Event(event, {
      bubbles: false, // Allows the event to bubble up the DOM tree
      cancelable: false // Allows the event to be canceled
    });
  };

  onPriceChangeLoading = (boolean) => {
    if (boolean) {
      this.variantTotalPrice.forEach((el) => {
        el.classList.add('hidden');
        el.nextElementSibling.classList.remove('hidden');
      });
      this.decreaseQuantity.setAttribute('disabled', true);
      this.increaseQuantity.setAttribute('disabled', true);
    } else {
      this.variantTotalPrice.forEach((el) => {
        el.classList.remove('hidden');
        el.nextElementSibling.classList.add('hidden');
      });
      this.decreaseQuantity.removeAttribute('disabled');
      this.increaseQuantity.removeAttribute('disabled');
    }
  };
}

customElements.define('variant-quantity', VariantQuantity);
